var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");

(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "../utils", "./fetch", "./xhr"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("../utils"), require("./fetch"), require("./xhr"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.utils, global.fetch, global.xhr);
    global.index = mod.exports;
  }
})(this, function (_exports, _utils, _fetch, _xhr) {
  "use strict";

  var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

  _Object$defineProperty(_exports, "__esModule", {
    value: true
  });

  _exports.default = proxy;
  _fetch = _interopRequireDefault(_fetch);
  _xhr = _interopRequireDefault(_xhr);

  // import { BEHAVIOR_TYPES_MAP } from '../constant'
  function proxy(beforeAction, afterAction) {
    var self = this; // 发起请求

    var _beforeAction = (0, _utils.tryCatchFn)(function (detail) {
      // 这里入队
      // self.behaviorQueue.enqueueWithCheck({
      //   type: BEHAVIOR_TYPES_MAP.BEHAVIOR_TYPES_API,
      //   ...detail,
      //   page: location.href
      // })
      beforeAction();
    }); // 请求结束


    var _afterAction = (0, _utils.tryCatchFn)(function (detail) {
      // 这里入队，仅记录失败请求
      // if (ifReportHttpError(detail.status, detail.url)) {
      // self.behaviorQueue.enqueueWithCheck({
      //   type: BEHAVIOR_TYPES_MAP.BEHAVIOR_TYPES_API,
      //   ...detail,
      //   page: location.href
      // })
      // }
      afterAction();
    });

    _fetch.default.call(self, _beforeAction, _afterAction);

    _xhr.default.call(self, _beforeAction, _afterAction);
  }
});